import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './pages/home/KingsPeroryTheme.css';
import SecurityWrapper from './components/security/SecurityWrapper';
const Home = lazy(() => import('./pages/home/Home'));
const AboutUs = lazy(() => import('./pages/about/AboutUs'));
const Contact = lazy(() => import('./pages/contact/Contact'));
const Courses = lazy(() => import('./pages/courses/Courses'));
const CourseDetails = lazy(() => import('./pages/courses/CourseDetails'));
const Feedback = lazy(() => import('./pages/feedback/Feedback'));
const Faq = lazy(() => import('./pages/faq/Faq'));
const TimeTables = lazy(() => import('./pages/timetables/TimeTables'));
const Login = lazy(() => import('./pages/auth/Login'));
const Register = lazy(() => import('./pages/auth/Register'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const StudentDashboard = lazy(() => import('./pages/student/StudentDashboard'));
const Exams = lazy(() => import('./pages/student/Exams'));
const Payments = lazy(() => import('./pages/student/Payments'));
const Profile = lazy(() => import('./pages/student/Profile'));
const MyCourses = lazy(() => import('./pages/student/MyCourses'));
const MonthSelection = lazy(() => import('./pages/student/MonthSelection'));
const CourseMaterials = lazy(() => import('./pages/student/CourseMaterials'));
const AllCourses = lazy(() => import('./pages/student/AllCourses'));
const PrivacyPolicy = lazy(() => import('./pages/legal/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/legal/TermsOfService'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Resources = lazy(() => import('./pages/Resources'));
const ManageGallery = lazy(() => import('./pages/admin/ManageGallery'));
const ManageResources = lazy(() => import('./pages/admin/ManageResources'));

function App() {
  return (
    <SecurityWrapper>
      <Router>
        <Suspense fallback={<div className="min-h-screen grid place-items-center" role="status">Loading…</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/course-details/:courseId" element={<CourseDetails />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/timetables" element={<TimeTables />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/admin/gallery" element={<ManageGallery />} />
        <Route path="/admin/resources" element={<ManageResources />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/student/dashboard" element={<StudentDashboard />} />
        <Route path="/student/courses" element={<MyCourses />} />
        <Route path="/student/all-classes" element={<AllCourses />} />
        <Route path="/student/course-months/:courseId" element={<MonthSelection />} />
        <Route path="/student/materials/:monthId" element={<CourseMaterials />} />
        <Route path="/student/exams" element={<Exams />} />
        <Route path="/student/payments" element={<Payments />} />
        <Route path="/student/profile" element={<Profile />} />
        </Routes>
        </Suspense>
    </Router>
    </SecurityWrapper>
  );
}

export default App;
